import React, { useState } from "react";
import { config } from "../config/config";
import NotaForm from "../components/NotaForm";
import NotaList from "../components/NotaList";
import showAlert from '../components/Alert';

const Notas = () => {
    const [editingNota, setEditingNota] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);

    const reloadNotasList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    const handleCreateOrUpdate = (nota) => {
        const url = editingNota
            ? `${config.apiUrl}/notas/${editingNota.nota_id}`
            : `${config.apiUrl}/notas`;
        const method = editingNota ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(nota),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error al guardar la información");
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingNota);
                setEditingNota(null);
                setResetForm(true);
                reloadNotasList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    const handleDelete = (id) => {
        if (window.confirm("¿Está seguro de que desea eliminar esta nota?")) {
            fetch(`${config.apiUrl}/notas/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Nota eliminada");
                    reloadNotasList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    return (
        <div>
            <NotaForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingNota}
                resetForm={resetForm}
            />
            <NotaList
                onEdit={(nota) => setEditingNota(nota)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger} // Pasamos reloadTrigger a NotasList
            />
        </div>
    );
};

export default Notas;
